import NeptuneElement from '../../NeptuneElement.js';
class Tooltip extends NeptuneElement {

    templateMarkup = `
        <div>
            <slot name="trigger-element"></slot>
            <div role="tooltip" id="tooltip-content" aria-hidden="true">
                <slot class="font-size-sm font-weight-regular" name="tooltip-text"></slot>
            </div>
        </div>
    `;

    componentCssUrl = '/src/components/core/tooltip/tooltip.css';

    constructor() {
        super();
        this.onTriggerEnter = this.onTriggerEnter.bind(this);
        this.onTriggerLeave = this.onTriggerLeave.bind(this);
        this.onTriggerFocus = this.onTriggerFocus.bind(this);
        this.onTriggerBlur = this.onTriggerBlur.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
    }

    async connectedCallback() {
        await super.connectedCallback();
        this.setEventListeners();
    }

    async disconnectedCallback() {
        this.removeEventListeners();
        await super.disconnectedCallback();
    }

    setEventListeners() {
        const slot = this.shadowRoot.querySelector('slot[name="trigger-element"]');
        slot?.addEventListener('slotchange', () => {
            this.attachTriggerListeners();
        });
        this.attachTriggerListeners();
    }

    removeEventListeners() {
        this.detachTriggerListeners();
    }

    attachTriggerListeners() {
        const trigger = this.getTriggerElement();
        if (!trigger) {return;}
        trigger.addEventListener('mouseenter', this.onTriggerEnter);
        trigger.addEventListener('mouseleave', this.onTriggerLeave);
        trigger.addEventListener('focus', this.onTriggerFocus);
        trigger.addEventListener('blur', this.onTriggerBlur);
        trigger.addEventListener('touchstart', this.onTouchStart, { passive: true });
        // accessibility
        trigger.setAttribute('aria-describedby', 'tooltip-content');
    }

    detachTriggerListeners() {
        const trigger = this.getTriggerElement();
        if (!trigger) {return;}
        trigger.removeEventListener('mouseenter', this.onTriggerEnter);
        trigger.removeEventListener('mouseleave', this.onTriggerLeave);
        trigger.removeEventListener('focus', this.onTriggerFocus);
        trigger.removeEventListener('blur', this.onTriggerBlur);
        trigger.removeEventListener('touchstart', this.onTouchStart);
        trigger.removeAttribute('aria-describedby');
    }

    getTooltipElement() {
        return this.shadowRoot?.getElementById('tooltip-content') ?? null;
    }

    getTriggerElement() {
        const slot = this.shadowRoot?.querySelector('slot[name="trigger-element"]');
        return slot?.assignedElements({ flatten: true })[0] ?? null;
    }

    onTriggerEnter() {
        this.showTooltip();
    }

    onTriggerLeave() {
        this.hideTooltip();
    }

    onTriggerFocus() {
        this.showTooltip();
    }

    onTriggerBlur() {
        this.hideTooltip();
    }

    onTouchStart() {
        const tooltip = this.getTooltipElement();
        if (!tooltip) {return;}
        if (tooltip.classList.contains('visibility-visible')) {
            this.hideTooltip();
        } else {
            this.showTooltip();
        }
    }

    showTooltip() {
        const tooltip = this.getTooltipElement();
        if (!tooltip) {return;}
        tooltip.classList.add('visibility-visible');
        tooltip.removeAttribute('aria-hidden');
    }

    hideTooltip() {
        const tooltip = this.getTooltipElement();
        if (!tooltip) {return;}
        tooltip.classList.remove('visibility-visible');
        tooltip.setAttribute('aria-hidden', 'true');
    }
}

customElements.define('neptune-tooltip', Tooltip);
export default Tooltip;
